<template>
    <form>
        <div class="alert alert-danger" v-if="error">{{error}}</div>
        <v-form-field label="Email" v-model="email" />
        <div class="mt-3">
            <v-form-field label="Password" type="password" v-model="password" />
        </div>
    </form>
</template>

<script>
import VFormField from "@/components/ui/VFormField";
import store from "@/store";

export default {
    name: "VFormSignIn",
    components: { VFormField },
    data() {
        return {
            saving: false,
            error: null,
            email: "",
            password: "",
            shared: store.state
        };
    },
    methods: {
        async signIn() {
            if (this.shared.user)
                return Promise.resolve(this.shared.user);
            this.error = null;
            this.saving = true;
            try {
                let response = await this.$ladder.signIn(
                    this.email,
                    this.password
                );
                store.setUser(response);
                this.$emit("authenticated", response);
                this.authenticated = true;
                this.me = response;
                return Promise.resolve(response);
            } catch (e) {
                // Show the error message
                this.error = e.message;
                // Emit an error event for parent components
                this.$emit("error", e);
                // Return a promise rejection for chaining flows
                return Promise.reject(e);
            } finally {
                this.saving = false;
            }
        },
        async signOut() {
            await this.$ladder.signOut();
            window.location.reload(true);
        }
    }
};
</script>